/**
 * useSourcesEntryScreen.js
 * ------------------------
 * Hook for Lead / Inquiry Source create/edit form screen using shared useMasterEntry.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as sourcesApi from '../api/sourcesApi';

export function useSourcesEntryScreen() {
  return useMasterEntry({
    entityName: 'Source',
    apiClient: sourcesApi.sourcesClient,
    fetchDetail: sourcesApi.getSourceDetail,
    createItem: sourcesApi.createSource,
    updateItem: sourcesApi.updateSource,
    initialForm: {
      name: '',
      short_name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Source Name is required.';
      }
      return null;
    },
    listPath: '/masters/sources/list',
    transformPayload: (form, operationalStatus) => ({
      name: form.name.trim(),
      short_name: form.short_name ? form.short_name.trim() : null,
      status: operationalStatus === 'active' ? 'Active' : 'Archived',
    }),
    transformDetail: (detail) => ({
      form: {
        name: detail.name || '',
        short_name: detail.short_name || '',
      },
      operationalStatus: detail.status === 'Active' ? 'active' : 'inactive',
    }),
  });
}
